import React from "react"
import { twMerge } from "tailwind-merge"

export type DisplayTagProps = {
  name: string
  logoUrl: string
  className?: string
  imgClassName?: string
}

export function DisplayTag({ name, logoUrl, className = "", imgClassName = "" }: DisplayTagProps) {
  return (
    <span className={twMerge("flex gap-2 items-center", className)}>
      <img src={logoUrl} className={twMerge("h-6 w-6", imgClassName)} />
      <span className="font-roboto font-medium text-grey-900 text-xs">{name.toUpperCase()}</span>
    </span>
  )
}
